import { Route, Routes } from 'react-router-dom';
import { Suspense, lazy } from 'react';
import TopNav from './components/TopNav';
import Footer from './components/Footer';
import SiteGate from './components/SiteGate';

// Eagerly loaded — light, on every page
import Landing from './routes/Landing';

// Lazy-loaded — only fetched when needed
const Pregled = lazy(() => import('./routes/Pregled'));
const SectionHub = lazy(() => import('./routes/SectionHub'));
const DimensionDetail = lazy(() => import('./routes/DimensionDetail'));
const VecaPitanja = lazy(() => import('./routes/VecaPitanja'));
const Glasovi = lazy(() => import('./routes/Glasovi'));
const Triage = lazy(() => import('./routes/Triage'));
const TriageCategory = lazy(() => import('./routes/TriageCategory'));
const Prepoznavanje = lazy(() => import('./routes/Prepoznavanje'));
const Brojke = lazy(() => import('./routes/Brojke'));
const Metodologija = lazy(() => import('./routes/Metodologija'));
const QuotePermalink = lazy(() => import('./routes/QuotePermalink'));
const SourcePermalink = lazy(() => import('./routes/SourcePermalink'));
const Odgovori = lazy(() => import('./routes/Odgovori'));
const NotFound = lazy(() => import('./routes/NotFound'));

function Loading() {
  return (
    <div className="mx-auto max-w-reading px-6 py-24 text-center text-neutral-500">
      <p className="font-serif italic">Učitava se…</p>
    </div>
  );
}

export default function App() {
  return (
    <SiteGate>
      <AppInner />
    </SiteGate>
  );
}

function AppInner() {
  return (
    <div className="flex min-h-screen flex-col">
      <TopNav />
      <main className="flex-1">
        <Suspense fallback={<Loading />}>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/pregled" element={<Pregled />} />

            {/* Two core section hubs */}
            <Route path="/operativa" element={<SectionHub axis="op" />} />
            <Route path="/operativa/:code" element={<DimensionDetail axis="op" />} />
            <Route path="/taktike-protivnika" element={<SectionHub axis="sn" />} />
            <Route path="/taktike-protivnika/:code" element={<DimensionDetail axis="sn" />} />

            {/* Secondary surfaces */}
            <Route path="/veca-pitanja" element={<VecaPitanja />} />
            <Route path="/veca-pitanja/:code" element={<VecaPitanja />} />
            <Route path="/glasovi" element={<Glasovi />} />

            {/* Permalinks */}
            <Route path="/citat/:id" element={<QuotePermalink />} />
            <Route path="/izvor/:rowId" element={<SourcePermalink />} />

            {/* Gated */}
            <Route path="/incidenti" element={<Triage />} />
            <Route path="/incidenti/prepoznavanje" element={<Prepoznavanje />} />
            <Route path="/incidenti/:category" element={<TriageCategory />} />

            {/* Service pages */}
            <Route path="/brojke" element={<Brojke />} />
            <Route path="/odgovori" element={<Odgovori />} />
            <Route path="/metodologija" element={<Metodologija />} />

            <Route path="*" element={<NotFound />} />
          </Routes>
        </Suspense>
      </main>
      <Footer />
    </div>
  );
}
